// Settings the admin area shares with the rest of the site.

// The shared API files this site's data under this id. The API now stores
// every website ID in lower case whatever the spelling sent; this matches it.
export const SITE_ID = "ploughingmatch";

// reCAPTCHA v3 site key (public), the one the contact and membership forms use.
export const RECAPTCHA_KEY = "6LfoFqwZAAAAANousPnb196-mOMNkw1lfFqW2e7k";

// The two roles the admin area knows. admin: messages and user management.
// editor: messages only. Stored lowercase by the API.
export const ROLES = {
  admin: { label: "Admin", description: "Messages and user accounts" },
  editor: { label: "Editor", description: "Messages only" },
};
